import classes from './team-inbox.module.scss';
import ChatView from "./chat-view";
import RowStack from '@common-components/common/row-stack/RowStack';
import { Box, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import ChatsSideBar from './chats-side-bar';
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import { selectUser } from '@common-reducers/UserSelectors';
import InlineSidebarTeamInbox from './inline-sidebar-team-inbox';
import ScheduledMessageEditorPopup from "@extension/context/content/components/add-scheduled-message-button/scheduled-message-editor-popup";
import ReminderEditorDialog from '@common/components/reminders/ReminderEditorDialog';
import ForwardMessageDialog from './forward-message-dialog';
import TopHeaderMain from '@/extension/context/content/components/labels-feature/top-header-main';
import { MQTTSubscriber } from '@common/noifier-module/MQTTSubscriber';
import { useHideCrisp } from '@common/hooks/use-hide-crisp';

const TeamInboxView = React.memo(() => {
    const theme = useTheme();
    const user = useAppSelector(selectUser);
    const userIsLoggedIn = !!user?._id;

    // Advertise "team inbox open" on this client's MQTT presence while the
    // view is mounted. The WhatsApp tab's event gate reads it to decide
    // whether team-inbox-relevant events are worth sending at all.
    useEffect(() => {
        const mqttSubscriber = MQTTSubscriber.getInstance();
        mqttSubscriber.setPresenceExtras({ teamInboxOpen: true });
        return () => {
            mqttSubscriber.setPresenceExtras({ teamInboxOpen: false });
        };
    }, []);

    // Team Inbox owns the bottom corners: no Crisp while it is mounted.
    useHideCrisp();

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            backgroundColor: theme.palette.background.default
        }}>
            <TopHeaderMain />

            {/* Main Content Area */}
            <RowStack
                className={classes.teamInboxViewWrapper}
                sx={{
                    flex: 1,
                    overflow: 'hidden',
                }}
            >
                <ChatsSideBar />
                <ChatView />
            </RowStack>

            {/* Inline Sidebar for Notes/Tasks/Scheduled Messages/Reminders/Quick Agents */}
            <InlineSidebarTeamInbox />

            {/* Schedule Message Dialog */}
            <ScheduledMessageEditorPopup />

            {/* Reminder create/edit dialog — same component WhatsApp Web mounts
                (reminders-injection); opened via RemindersUIReducer.openEditor */}
            <ReminderEditorDialog />

            {/* WhatsApp-style "Forward message to…" picker — opens when a
                message is staged via TeamInboxReducer.forwardingMessage */}
            <ForwardMessageDialog />
        </Box>
    );
});

export default TeamInboxView;
